import { Component, Prop, Ref, Watch } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import {
    elevate,
    type Algorithm,
    type RecommendationList,
    type CartPage,
    type ProductPage,
    type LandingPage,
} from '@apptus/esales-api';
import { ProductDetails } from "../Product/ProductDetails";
import { VoyadoProductCard } from './VoyadoProductCard';

declare global {
    interface Window {
        elevate: ReturnType<typeof elevate>;
    }
}

@Component
export class VoyadoCompleteTheLook extends ThemeComponent {
    @Ref container!: HTMLElement;

    private _recommendations?: RecommendationList;

    set recommendations(recommendations: RecommendationList | undefined) {
        this._recommendations = recommendations;
        this.renderRecommendations();
    }

    get recommendations() {
        return this._recommendations;
    }

    init() {
        this.listenForProductLoad();
    }

    private listenForProductLoad() {
        const productDetails = document.querySelector('product-details') as ProductDetails;

        this.$subscribe(productDetails.onVoyadoProductLoaded, (result) => {
            this.parseResult(result);
        });
    }

    parseResult(result: ProductPage) {
        if (result.recommendationLists.length > 0) {
            this.recommendations = result.recommendationLists.find(({ algorithm }) => algorithm == 'STYLE_WITH');
        } else {
            this.recommendations = undefined;
        }

        this.renderRecommendations();
    }

    renderRecommendations() {
        if (!this.recommendations) {
            return;
        }

        const documentFragment = document.createDocumentFragment();

        for (const productGroup of this.recommendations.productGroups) {
            const card = new VoyadoProductCard;
            card.section = 'voyado-complete-the-look-card';
            card.setAttribute('data-ref', 'carouselCard');
            card.productGroup = productGroup;

            documentFragment.appendChild(card);
        }

        this.container.replaceChildren(documentFragment);
    }
}
